import { FontSizeToken, ThemeFontStylesType } from "../../Font/types";
import { Platforms } from "../../types";
import { fontStylesTokens } from "../constants";
import commonGetter from "./commonGetter";

const getLineHeightValue = (
  { lineHeight }: FontSizeToken["data"],
  platform: Platforms
) => {
  switch (platform) {
    case "web":
      return lineHeight;
    case "reactNative":
      return lineHeight;
    default:
      return lineHeight;
  }
};

export default <T extends Platforms>(platform: T) =>
  commonGetter({
    platform,
    tokens: fontStylesTokens[platform],
    getValue: getLineHeightValue,
  }) as ThemeFontStylesType["LineHeights"][T];
